import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import { fetchScreenshots } from "../api/opsApi";

// The monthly screenshot competition: this month's winner large, every month before it below.
export default function ScreenshotsPage() {
  const [entries, setEntries] = useState(null);
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    fetchScreenshots({ signal: controller.signal })
      .then(setEntries)
      .catch((error) => {
        if (error.name !== "AbortError") setFailed(true);
      });
    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(null);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const [latest, ...rest] = entries ?? [];

  return (
    <>
      <PageTitle>vWZZ - Screenshots</PageTitle>
      <div className="page-container shots-page">
        <header className="shots-header">
          <h1 className="page-title">Screenshots</h1>
          <p className="page-subtitle">
            Every month our pilots send in their best shot from the line. These are the
            ones that won.
          </p>
        </header>

        {failed ? (
          <p className="shots-empty">The winners could not be loaded just now.</p>
        ) : entries === null ? (
          <p className="shots-empty">Loading...</p>
        ) : !entries.length ? (
          <p className="shots-empty">
            The first competition has not been judged yet. Check back at the end of the
            month.
          </p>
        ) : (
          <>
            <section className="shots-latest">
              <button type="button" onClick={() => setOpen(latest)} aria-label={`Enlarge ${latest.title}`}>
                <img src={latest.image} alt={latest.title} />
              </button>
              <div className="shots-latest-copy">
                <h2>{latest.title}</h2>
                {latest.credit ? <p className="shots-credit">By {latest.credit}</p> : null}
                {latest.description ? <p>{latest.description}</p> : null}
              </div>
            </section>

            {rest.length ? (
              <section className="shots-archive" aria-labelledby="shots-archive-title">
                <h2 id="shots-archive-title">Previous winners</h2>
                <div className="shots-grid">
                  {rest.map((entry) => (
                    <figure className="shots-card" key={entry.id}>
                      <button type="button" onClick={() => setOpen(entry)} aria-label={`Enlarge ${entry.title}`}>
                        <img src={entry.image} alt={entry.title} loading="lazy" decoding="async" />
                      </button>
                      <figcaption>
                        <strong>{entry.title}</strong>
                        {entry.credit ? <span>By {entry.credit}</span> : null}
                      </figcaption>
                    </figure>
                  ))}
                </div>
              </section>
            ) : null}
          </>
        )}

        <section className="shots-enter">
          <div>
            <h2>Entering</h2>
            <p>
              Post your shot in the screenshots channel on our Discord during the month.
              Anything flown on the vWZZ network counts.
            </p>
          </div>
          <Link className="btn btn-primary" to="/apply">
            Join vWZZ
          </Link>
        </section>

        {open ? (
          <div
            className="shots-lightbox"
            role="dialog"
            aria-modal="true"
            aria-label={open.title}
            onMouseDown={(event) => {
              if (event.target === event.currentTarget) setOpen(null);
            }}
          >
            <button
              type="button"
              className="shots-lightbox-close"
              onClick={() => setOpen(null)}
              aria-label="Close"
              autoFocus
            >
              Close
            </button>
            <figure>
              <img src={open.image} alt={open.title} />
              <figcaption>
                <strong>{open.title}</strong>
                {open.credit ? <span>By {open.credit}</span> : null}
                {open.description ? <span>{open.description}</span> : null}
              </figcaption>
            </figure>
          </div>
        ) : null}
      </div>
    </>
  );
}
